<template>
  <section class="html-content-block">
    <div class="html-content-block__container">
      <div class="html-content-block__content" v-html="data.content"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppHtmlContentBlock',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({})
    }
  }
};
</script>

<style scoped>
.html-content-block {
  padding: 40px 0;
}

.html-content-block__container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
}

.html-content-block__content {
  font-size: 18px;
  line-height: 1.6;
  color: #333;
}

.html-content-block__content >>> h1,
.html-content-block__content >>> h2,
.html-content-block__content >>> h3 {
  color: #2c3e50;
  margin-bottom: 20px;
}

.html-content-block__content >>> p {
  margin-bottom: 15px;
}

.html-content-block__content >>> ul,
.html-content-block__content >>> ol {
  margin-left: 20px;
  margin-bottom: 15px;
}

.html-content-block__content >>> a {
  color: #007bff;
  text-decoration: none;
}

.html-content-block__content >>> a:hover {
  text-decoration: underline;
}

.html-content-block__content >>> img {
  max-width: 100%;
  height: auto;
  border-radius: 5px;
}
</style>